var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.load,
                  expression: "load"
                }
              ],
              staticClass: "main",
              attrs: {
                "infinite-scroll-delay": "200",
                "infinite-scroll-distance": "200"
              }
            },
            [
              _c("SubTitleComponent", {
                attrs: { title: _vm.title, type: "client" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "div",
                    { staticClass: "filter" },
                    [
                      _c(
                        "el-tag",
                        {
                          staticClass: "item",
                          attrs: {
                            type: "success",
                            effect: _vm.styleCur == -1 ? "dark" : "plain"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onChange(-1)
                            }
                          }
                        },
                        [_vm._v("全部")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.styleData, function(item, index) {
                        return _c(
                          "el-tag",
                          {
                            key: index,
                            staticClass: "item",
                            attrs: {
                              type: "success",
                              effect: _vm.styleCur == index ? "dark" : "plain"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onChange(index)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.style_type))]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "waterfall",
                    {
                      staticClass: "waterfall",
                      attrs: {
                        col: 4,
                        gutterWidth: 20,
                        data: _vm.materialData,
                        lazyDistance: 200
                      }
                    },
                    [
                      _vm._l(_vm.materialData, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "waterfall-item" },
                          [
                            _c("img", {
                              staticClass: "image",
                              attrs: { src: item.photo_url },
                              on: {
                                click: function($event) {
                                  return _vm.toDetail(index)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "name" }, [_vm._v(" ")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { class: item.is_vote == 1 ? "vote on" : "vote" },
                              [_vm._v(_vm._s(item.vote))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisit,
                    width: "60%",
                    "show-close": false,
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisit = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "img" }, [
                    _vm.dialogCur != -1
                      ? _c("img", {
                          attrs: {
                            src: _vm.materialData[_vm.dialogCur].photo_url,
                            alt: ""
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _vm.dialogCur != -1
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon:
                                  _vm.materialData[_vm.dialogCur].is_vote == 1
                                    ? "el-icon-like-on"
                                    : "el-icon-like"
                              },
                              on: { click: _vm.toVote }
                            },
                            [_vm._v("点赞")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.toPath } }, [
                        _vm._v("生成同款")
                      ])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a200571a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a200571a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/IndexClient.vue
// module id = null
// module chunks = 